import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "../static/rem.js"
import 'reset.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import i18n from './i18n/i18n'
import VueLazyload from "vue-lazyload"
import VueParticles from 'vue-particles'
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.scss'
import "./style/border.css"
import {
  Select,
  Option,
  Loading,
  Form,
  FormItem,
  Input,
  Button,
  Message,
  Divider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Pagination
} from 'element-ui'
import MetaInfo from 'vue-meta-info'
import { get } from "./ajax/request"
Vue.use(MetaInfo)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Pagination);
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.use(VueLazyload)
Vue.use(VueAwesomeSwiper)
Vue.use(VueParticles)
Vue.config.productionTip = false
Vue.prototype.$get = get
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js